import { render, staticRenderFns } from "./Palavra.vue?vue&type=template&id=437d6e41&scoped=true&"
import script from "./Palavra.vue?vue&type=script&lang=js&"
export * from "./Palavra.vue?vue&type=script&lang=js&"
import style0 from "./Palavra.vue?vue&type=style&index=0&id=437d6e41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437d6e41",
  null
  
)

export default component.exports